import { render, staticRenderFns } from "./ecologicalSolution.vue?vue&type=template&id=3d3a7c5f&scoped=true"
import script from "./ecologicalSolution.vue?vue&type=script&lang=js"
export * from "./ecologicalSolution.vue?vue&type=script&lang=js"
import style0 from "./ecologicalSolution.vue?vue&type=style&index=0&id=3d3a7c5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3a7c5f",
  null
  
)

export default component.exports